// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BestEnrollmentV2Model } from './bestEnrollmentV2Model.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': Array<BestEnrollmentV2Model>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<BestEnrollmentV2Model>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentEnrollmentGetBestEnrollmentsV2DefaultResponse.attributeTypeMap;
    }
}
